import GeolocationCreate from './Create'
import GeolocationEdit from './Edit'
import GeolocationList from './List'

export default {
  list: GeolocationList,
  create: GeolocationCreate,
  edit: GeolocationEdit
}
